import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-customer-branding-logo',
    imports: [
        NgOptimizedImage
    ],
  templateUrl: './customer-branding-logo.component.html',
  styleUrl: './customer-branding-logo.component.css'
})
export class CustomerBrandingLogoComponent {

}
